module.exports = __webpack_public_path__ + "static/media/qingdao_pic2.46542cb7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/qingdao_pic2.jpg
 ** module id = 471
 ** module chunks = 0
 **/